const TrendyolMenuTypes = {
    CHANNEL: {
        id: "detail",
        group: "settings_group",
        path: "detail",
        label: "Detail",
        tabs: [],
        implemented: true,
    },
    VISIBILITY: {
        id: "visibility",
        group: "settings_group",
        path: "visibility",
        label: "Visibility",
        tabs: [],
        implemented: true,
    },
    QUESTION_MANAGEMENT: {
        id: "questions",
        group: "brand",
        path: "questions",
        label: "Ürün Soru Yönetimi",
        tabs: [],
        implemented: true,
    },
};

export default TrendyolMenuTypes;
